import * as actions from "./actions";
import { rootRef } from "../../config/firebase";
import _ from "lodash";

function resetSavedData() {
  return actions.resetDataSaved();
}

function resetSearchData() {
  return actions.resetSearchData();
}

function resetSearchDataActividades() {
  return actions.resetSearchDataActividades();
}

function resetSearchDataAlumnos() {
  return actions.resetSearchDataAlumnos();
}

function fetchSearchDataAlumnos() {
  return dispatch =>
    rootRef.child("detalles/alumnos").on("child_added", snap => {
      const alumno = snap.val();
      let payload = {
        childKey: snap.key,
        title: `${alumno.nombre} ${alumno.apellido1} ${alumno.apellido2}`,
        description: !_.isEmpty(alumno.colegioestudios)
          ? `${alumno.colegioestudios.nombre} - ${
              alumno.colegioestudios.poblacion
            } ${alumno.colegioestudios.provincia}`
          : ""
      };
      dispatch(actions.fetchSearchDataAlumnos(payload));
    });
}

function fetchSearchDataColegios() {
  return dispatch =>
    rootRef.child("detalles/colegios").on("child_added", snap => {
      const colegio = snap.val();
      let payload = {
        childKey: snap.key,
        title: `${colegio.nombre}`,
        description: `${colegio.poblacion} ${colegio.provincia}`
      };
      dispatch(actions.fetchSearchDataColegios(payload));
    });
}

function detachSearchData() {
  return dispatch => {
    rootRef.child("detalles/alumnos").off("child_added");
    rootRef.child("detalles/colegios").off("child_added");
    rootRef.child("detalles/actividades").off("child_added");
  };
}

function detachSearchActividadesCobro(idColegio) {
  return dispatch =>
    rootRef.child(`actividades_por_colegio/${idColegio}`).off("child_added");
}

function fetchSearchDataActividades() {
  return dispatch =>
    rootRef.child("detalles/actividades").on("child_added", snap => {
      const actividad = snap.val();
      let payload = {
        childKey: snap.key,
        title: `${actividad.nombre} (${actividad.importe} €)`,
        description: `${actividad.descripcion}`
      };
      dispatch(actions.fetchSearchDataActividades(payload));
    });
}

function putVariasActividades() {
  return dispatch => {
    const payload = {
      childKey: "V.actividades",
      title: `Varias Actividades`
    };
    dispatch(actions.fetchSearchDataActividades(payload));
  };
}

function obtenerSearchDataActividadesCobro(idColegio) {
  return dispatch =>
    rootRef
      .child(`actividades_por_colegio/${idColegio}`)
      .orderByChild("finalizada")
      .equalTo(false)
      .on("child_added", snap => {
        if (snap.hasChildren()) {
          const { actividad, importe } = snap.val();

          const payload = {
            childKey: snap.key,
            title: `${actividad} (${importe} €)`
          };
          dispatch(actions.fetchSearchDataActividades(payload));
        }
      });
}

function fetchSearchDataEscuelas() {
  let prom = [
    rootRef.child("escuelas/verano2018/preinscripciones").once("value"),
    rootRef.child("escuelas/verano2018/inscripciones").once("value")
  ];

  return dispatch =>
    Promise.all(prom)
      .then(resp => {
        let nombres = [];
        let resguardos = [];
        let colegiosPromises = {};

        resp.forEach(snap => {
          const datos = snap.val();
          _.forOwn(datos, (inscrips, colegio) => {
            colegiosPromises[colegio] = rootRef
              .child(`detalles/colegios/${colegio}`)
              .once("value");

            _.forOwn(inscrips, (valor, idInscripcion) => {
              nombres.push({
                childKey: idInscripcion,
                title: `${valor.nombre} ${valor.apellido1}`,
                colegio,
                confirmado: valor.confirmado ? "si" : "no"
              });
              resguardos.push({
                childKey: idInscripcion,
                title: idInscripcion,
                colegio,
                confirmado: valor.confirmado ? "si" : "no"
              });
            });
          });

          let colegios = [];
          Promise.all(Object.values(colegiosPromises))
            .then(resp => {
              colegios = resp.map(r => ({
                childKey: r.key,
                title: r.val().nombre
              }));
              dispatch(actions.fetchSearchDataEscuelasColegios(colegios));
            })
            .catch(error => console.log(error));
          dispatch(actions.fetchSearchDataEscuelasNombres(nombres));
          dispatch(actions.fetchSearchDataEscuelasResguardo(resguardos));
        });
      })
      .catch(error => console.log(error));
}

function resetSearchDataEscuelas() {
  return actions.resetSearchDataEscuelas();
}
/*---*/
export {
  resetSavedData,
  resetSearchData,
  resetSearchDataActividades,
  resetSearchDataAlumnos,
  fetchSearchDataAlumnos,
  fetchSearchDataColegios,
  fetchSearchDataActividades,
  putVariasActividades,
  obtenerSearchDataActividadesCobro,
  detachSearchActividadesCobro,
  detachSearchData,
  fetchSearchDataEscuelas,
  resetSearchDataEscuelas
};



// WEBPACK FOOTER //
// ./src/ducks/busquedas/operations.js